import React from 'react'
import { Box, Flex } from 'reflexbox'
import classnames from 'classnames'

import LinkComponent from 'src/components/LinkComponent/LinkComponent'

import * as styles from './ButtonText.module.scss'
import { Props } from './types'

const ButtonContent = ({ children }: Props): JSX.Element => (
  <Flex alignItems="center">
    <Box className={styles.text} textAlign="left">
      {children}
    </Box>
  </Flex>
)

const ButtonText = ({
  onClick,
  to,
  title,
  children,
  className = '',
  customIcon,
  theme = '',
  useIcon = true,
}: Props): JSX.Element => {
  const buttonStyles = classnames(
    styles.button,
    theme === 'light' ? styles.lightTheme : '',
    className
  )
  return onClick && !to ? (
    <Flex as="button" onClick={onClick} className={buttonStyles}>
      <ButtonContent customIcon={customIcon} useIcon={useIcon}>
        {children}
      </ButtonContent>
    </Flex>
  ) : to ? (
    <LinkComponent
      to={to}
      onClick={onClick}
      title={title}
      className={buttonStyles}
    >
      <ButtonContent customIcon={customIcon} useIcon={useIcon}>
        {children}
      </ButtonContent>
    </LinkComponent>
  ) : (
    <div />
  )
}

export default ButtonText
